// Watch for changes to the responsive menu and add a class to the top nav buy rocc link when the menu is open
// This is used to hide the top nav buy rocc link when the mobile menu is open
// This is a workaround for the fact that the mobile menu is not part of the top nav buy rocc link
document.addEventListener('DOMContentLoaded', function() {
    const responsiveMenu = document.querySelector('ul#responsiveMenu');
    const topNavBuyRocc = document.querySelector('nav a.top-nav-buy-rocc');
    const customerLinks = document.querySelector('div.customer-links');
    const headerNav = document.getElementById('header-navigation');

    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.attributeName === 'class') {
                if (responsiveMenu.classList.contains('open')) {
                    topNavBuyRocc.classList.add('mobile-menu-open');
                    headerNav.classList.add('mobile-menu-open');
                    customerLinks.classList.add('mobile-menu-open');
                } else {
                    topNavBuyRocc.classList.remove('mobile-menu-open');
                    headerNav.classList.remove('mobile-menu-open');
                    customerLinks.classList.remove('mobile-menu-open');
                }
            }
        });
    });

    observer.observe(responsiveMenu, {
        attributes: true // configure it to listen to attribute changes
    });
});

// Ensure elements with aria-hidden set to true don't have focusable descendents
const ariaHiddenObserver = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type === 'attributes' || mutation.type === 'childList') {
      syncHiddenTabindex();
    }
  });
});

ariaHiddenObserver.observe(document.body, {
  attributes: true,
  childList: true,
  subtree: true,
  attributeFilter: ['aria-hidden']
});

function syncHiddenTabindex() {
  const hiddenContainers = document.querySelectorAll('[aria-hidden="true"]');
  hiddenContainers.forEach(container => {
    const focusableItems = container.querySelectorAll('a, button');
    focusableItems.forEach(item => {
      if (item.getAttribute('tabindex') !== '-1') {
        item.setAttribute('tabindex', '-1');
      }
    });
  });
}

// Injects Skip Buttons around the Habitat Video Carousel
function injectCarouselSkipButtons() {
  const targetDiv = document.querySelector('[data-widget-host="habitat-static-feed"]');
  
  if (!targetDiv) return;

  const afterCarouselId = 'after-video-carousel-target';
  const beforeCarouselId = 'before-video-carousel-target';

  if (!document.getElementById(afterCarouselId)) {
    const afterTarget = document.createElement('div');
    afterTarget.id = afterCarouselId;
    afterTarget.tabIndex = -1; 
    targetDiv.parentNode.insertBefore(afterTarget, targetDiv.nextSibling);
  }

  if (!document.getElementById(beforeCarouselId)) {
    const beforeTarget = document.createElement('div');
    beforeTarget.id = beforeCarouselId;
    beforeTarget.tabIndex = -1;
    targetDiv.parentNode.insertBefore(beforeTarget, targetDiv);
  }

  if (!document.querySelector('.skip-video-carousel')) {
    const skipBtn = document.createElement('button');
    skipBtn.className = 'skip-video-carousel accessibility-skip-btn';
    skipBtn.innerText = 'Skip video carousel';
    skipBtn.onclick = () => document.getElementById(afterCarouselId).focus();
    
    targetDiv.parentNode.insertBefore(skipBtn, document.getElementById(beforeCarouselId));
  }

  if (!document.querySelector('.skip-back-carousel')) {
    const backBtn = document.createElement('button');
    backBtn.className = 'skip-back-carousel accessibility-skip-btn';
    backBtn.innerText = 'Skip to before video carousel';
    backBtn.onclick = () => document.getElementById(beforeCarouselId).focus();
    
    targetDiv.parentNode.insertBefore(backBtn, document.getElementById(afterCarouselId).nextSibling);
  }
}
if (document.readyState === 'complete' || document.readyState === 'interactive') {
  injectCarouselSkipButtons();
} else {
  document.addEventListener('DOMContentLoaded', injectCarouselSkipButtons);
}

// Keyboard Controls for Cart Button - Simulate click on keydown
function handleCartEnterKey() {
  const cartContainer = document.getElementById('cart-count-desktop');
  if (!cartContainer) return;

  const cartLink = cartContainer.querySelector('a[title="Cart"]');
  if (!cartLink) return;

  cartLink.addEventListener('keydown', function(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      this.click();
      console.log('Cart click triggered via Enter key');
    }
  });
}
if (document.readyState === 'complete' || document.readyState === 'interactive') {
  handleCartEnterKey();
} else {
  document.addEventListener('DOMContentLoaded', handleCartEnterKey);
}

// Keyboard nav update - Allow keyboard nav users to visit parent links, proper aria-expanded expression
(function() {
  let ariaTimeout;

  function syncMenuState(currentLink) {
    // Only run if we are in Desktop mode
    if (document.body.classList.contains('mobile-only')) return;

    const parentLinks = document.querySelectorAll('.responsiveMenu li.parent > a.parent');
    const currentLi = currentLink.parentElement;

    clearTimeout(ariaTimeout);

    parentLinks.forEach(link => {
      if (link !== currentLink) {
        link.parentElement.classList.remove('hover');
        link.setAttribute('aria-expanded', 'false');
      }
    });

    // Delayed "Open" State
    ariaTimeout = setTimeout(() => {
      currentLi.classList.add('hover');
      currentLink.setAttribute('aria-expanded', 'true');
    }, 50);
  }

  function initMenuFix() {
    const parentLinks = document.querySelectorAll('.responsiveMenu li.parent > a.parent');

    parentLinks.forEach(link => {
      // Fix Focus Announcement
      link.addEventListener('focus', (e) => syncMenuState(e.currentTarget));

      // Fix Enter Key Navigation
      link.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          const destination = link.getAttribute('href');
          // If the menu is open and has a destination, navigate immediately
          if (link.getAttribute('aria-expanded') === 'true' && destination && destination !== '#') {
            e.stopPropagation();
            window.location.href = destination;
          }
        }
      });
    });

    // Close menu when focus leaves the navigation entirely
    const nav = document.querySelector('nav[aria-label="Main Menu"]');
    if (nav) {
      nav.addEventListener('focusout', (e) => {
        if (!nav.contains(e.relatedTarget)) {
          clearTimeout(ariaTimeout);
          parentLinks.forEach(link => {
            link.parentElement.classList.remove('hover');
            link.setAttribute('aria-expanded', 'false');
          });
        }
      });
    }
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    initMenuFix();
  } else {
    document.addEventListener('DOMContentLoaded', initMenuFix);
  }
})();